import { Button } from '@/components/ui/button.js';
import { Calendar } from '@/components/ui/calendar.js';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover.js';
import { PlusCircle } from 'lucide-react';
import { useState } from 'react';
import { DayPickerRangeProps } from 'react-day-picker';
import { Temporal } from 'temporal-polyfill';
import { localDateFromPlainDate, plainDateFromLocalDate } from '@/lib/time-zones.js';

export interface TableFilterDateRangePickerProps {
  calendarProps?: Omit<DayPickerRangeProps, 'mode'>;
  placeholder?: string;
  fromPlainDateString?: string;
  toPlainDateString?: string;
  onRangeSelect: (rangeInPlainDateString: { fromPlainDateString?: string; toPlainDateString?: string }) => void;
  buttonTestId?: string;
}

export const TableFilterPlainDateRangePicker = ({
  calendarProps = {},
  placeholder,
  fromPlainDateString,
  toPlainDateString,
  onRangeSelect,
  buttonTestId,
}: TableFilterDateRangePickerProps) => {
  const { ...othersCalendarProps } = calendarProps;
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  return (
    <>
      <Popover open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm" className="h-8 border-dashed" data-testid={buttonTestId}>
            <PlusCircle className="mr-2 h-4 w-4" />
            {fromPlainDateString || toPlainDateString ? (
              <span>{`${fromPlainDateString || ''} -- ${toPlainDateString || ''}`}</span>
            ) : (
              <span>{placeholder}</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="range"
            {...othersCalendarProps}
            onSelect={(range) => {
              onRangeSelect?.({
                fromPlainDateString: range?.from ? plainDateFromLocalDate(range.from).toString() : undefined,
                toPlainDateString: range?.to ? plainDateFromLocalDate(range.to).toString() : undefined,
              });
            }}
            selected={{
              from: fromPlainDateString
                ? localDateFromPlainDate(Temporal.PlainDate.from(fromPlainDateString))
                : undefined,
              to: toPlainDateString ? localDateFromPlainDate(Temporal.PlainDate.from(toPlainDateString)) : undefined,
            }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </>
  );
};
